import React, { useState } from 'react';
import { FaBars } from 'react-icons/fa';
import PropTypes from 'prop-types';
import { Collapse } from 'reactstrap';
import SidebarContent from '../sidebar/SidebarContent';
import { UserProps } from 'src/shared/prop-types/ReducerProps';
import TopbarProfile from './TopbarProfile';
import TopbarLanguage from './TopbarLanguage';
import TopbarNotification from './TopbarNotification';
import TopBarClientInformation from './TopBarClientInformation';

const pndlogo = `../../../../../../img/pnd/pndlogo.png`;
const Topbar = ({
  user, productRoute, changeMobileSidebarVisibility, changeSidebarVisibility, changeToDark, changeToLight
}) => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  return (
    <div className="topbar">
      <div className="topbar__left">
        <button className="topbar__btn topbar__btn--mobile" onClick={toggleMobileMenu}>
          <FaBars />
        </button>
        <button className="topbar__btn topbar__btn--desktop" onClick={changeSidebarVisibility}>
          <FaBars />
        </button>
        <img className="topbar__logo" src={pndlogo} alt="startup landing logo" />
        <TopBarClientInformation />
      </div>

      <div className="topbar__right">
        <div className="topbar__right-over">
          <TopbarNotification />
          <TopbarProfile user={user} productRoute={productRoute} />
          <TopbarLanguage />
        </div>
      </div>

      {/* Mobile Top Menu Dropdown */}
      <Collapse isOpen={isMobileMenuOpen} className="topbar__mobile-menu"
        style={{
          position: 'fixed', // Fixed to cover content
          top: '60px', // Below topbar height
          left: 0,
          right: 0,
          backgroundColor: '#ffffff',
          zIndex: 1000, // Above everything
          boxShadow: '0 4px 15px rgba(0,0,0,0.1)',
          maxHeight: 'calc(100vh - 60px)',
          overflowY: 'auto',
          borderTop: '1px solid #f0f0f0'
        }}
      >
        <div style={{ padding: '15px 0' }}>
          <SidebarContent
            onClick={() => setIsMobileMenuOpen(false)}
            changeToDark={changeToDark}
            changeToLight={changeToLight}
            sidebarCollapse={false} // Ensure expanded
          />
        </div>
      </Collapse>
    </div>
  );
};

Topbar.propTypes = {
  changeMobileSidebarVisibility: PropTypes.func.isRequired,
  changeSidebarVisibility: PropTypes.func.isRequired,
  changeToDark: PropTypes.func,
  changeToLight: PropTypes.func,
  user: UserProps,
};


export default Topbar;


